import { styled, css } from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  width: 100%;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  .ds-advanced-select-display {
    justify-content: space-between;
  }
`;

export const SectionLabel = styled.span`
  ${({ theme: { colors, fontSizes, fontWeights } }) => css`
    color: ${colors.brandDarkTint30};
    font-size: ${fontSizes.s12};
    font-weight: ${fontWeights.medium};
  `}
`;

export const FormatGroup = styled.div`
  ${({ theme: { colors } }) => css`
    display: flex;
    border-radius: 0.25rem;

    .button {
      border: 0;
      min-width: 4rem;
    }

    .button-active {
      background: ${colors.brandPrimaryAlpha5};
      color: ${colors.brandPrimary};
    }
  `}
`;

export const Footer = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  padding-top: 2rem;
  width: 100%;
`;

export const PeriodList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const PeriodOption = styled.div<{ $isSelected: boolean }>`
  ${({ theme: { borderRadius, colors, fontSizes, fontWeights, motionSpeeds, motions }, $isSelected }) => css`
    align-items: center;
    border-radius: ${borderRadius.sm};
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    outline: 2px solid transparent;
    transition: all ${motionSpeeds.fast} ${motions.default};
    user-select: none;

    span {
      color: ${colors.brandDark};
      font-size: ${fontSizes.s14};
      font-weight: ${fontWeights.regular};
    }

    .icon {
      height: 1rem;
      width: 1rem;
    }

    .radio {
      align-items: center;
      flex: 1;
      gap: 0.5rem;
      line-height: 1em;
      margin: 0;
      min-height: unset;
      padding: 0;

      input {
        float: unset;
        margin-left: unset;
      }
    }

    &:last-child {
      .radio {
        flex: unset;
      }
    }

    .date-picker {
      button {
        background: transparent;
        border: 0;
        height: auto;
        padding: 0;
        outline: 0;
      }
    }

    ${
      $isSelected &&
      css`
        z-index: 1;
      `
    }
  `}
`;

export const CustomDateRow = styled.div`
  align-items: center;
  display: flex;
  gap: 0.5rem;

  .date-picker {
    flex: 1;
  }
`;
